import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';
import { I18nProvider } from '@/contexts/I18nContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { AgentModeProvider } from '@/contexts/AgentModeContext';
import { BrandAccent } from '@/components/BrandAccent';
import { TooltipProvider } from '@/components/shadcn/tooltip';
import { Toaster } from '@/components/shadcn/sonner';
import { AppRoutes } from '@/routes';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/app">
        <ThemeProvider>
          <I18nProvider>
            <TooltipProvider delayDuration={200}>
              <AuthProvider>
                <AgentModeProvider>
                  <BrandAccent />
                  <AppRoutes />
                </AgentModeProvider>
              </AuthProvider>
              <Toaster />
            </TooltipProvider>
          </I18nProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
